<!-- 首页-->
<template>
  <div class="index-page">
    <swiper class="swiper-box" :options="swiperOption" ref="mySwiper" v-if="baseInfo">
      <swiper-slide class="swiper-item" v-for="(item,index) in screenWidth > 750 ? bannerList : mobileBannerList" :key="index">
        <router-link class="swiper-link" :to="item.url" v-if="item.url !== 'no'">
          <img :class="screenWidth > 750 ? 'img-cover' : 'img-fill'" :src="`${ajaxUrl}${item.image}`" alt="">
        </router-link>
        <img :class="screenWidth > 750 ? 'img-cover' : 'img-fill'"  :src="`${ajaxUrl}${item.image}`" alt="" v-else>
        <div class="banner4 pa flex-c" v-if="index === 5">
          <router-link :to="`/detail?id=${news.id}`" class="ban4-item flex-column-c-c" v-for="news in newsList" :key="news.id">
            <div class="item-img">
              <img class="img-cover" :src="`${ajaxUrl}${news.image}`" alt="">
            </div>
            <div class="item-date">{{news.publish_at}}</div>
            <div class="item-line pr"></div>
            <div class="item-title ellipsis_2">{{news.title}}</div>
          </router-link>
        </div>
        <div class="mobile-banner-case pa" v-if="index === 4">
          <div class="mobile-banner-case-header">工程案例</div>
          <div class="mobile-banner-case-line"></div>
          <div class="flex-wrap case-list">
            <router-link :to="`/caseDetail?id=${news.id}`" class="case-item" v-for="news in caseList" :key="news.id">
              <img class="img-cover" :src="`${ajaxUrl}${news.image}`" alt="">
              <div class="item-title ellipsis_1">{{news.title}}</div>
            </router-link>
          </div>
        </div>
        <!--工具栏-->
        <div class="index-tool">
          <router-link to="/contact" class="tool-item flex-c-c">
            <i class="el-icon-phone-outline"></i>
          </router-link>
          <router-link to="/contact" class="tool-item flex-c-c">
            <i class="el-icon-location-outline"></i>
          </router-link>
          <el-tooltip class="tool-item flex-c-c" effect="dark" placement="left">
            <i class="el-icon-full-screen"></i>
            <div slot="content">
              <div class="w150">
                <img class="img-cover" :src="`${ajaxUrl}${baseInfo.web_qrcode}`" alt="">
              </div>
            </div>
          </el-tooltip>
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
  import {ajaxGet, ajaxPost, ajaxUrl} from "../utils/ajax";
  export default {
    name: "Index",
    data(){
      return{
        ajaxUrl,
        swiperOption:{
          loop: false,
          autoplay: {
            disableOnInteraction: true,
            delay: 5000,
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          on:{
            slideChange: () => {
              if(this.screenWidth > 750){ 
                this.$emit('handleRed', false);
                if(this.$refs.mySwiper.$swiper) {
                  console.log(this.$refs.mySwiper.$swiper.activeIndex);
                  if(this.$refs.mySwiper.$swiper.activeIndex === 1 || this.$refs.mySwiper.$swiper.activeIndex === 3 || this.$refs.mySwiper.$swiper.activeIndex === 4) {
                    this.$emit('handleRed', true);
                  }
                }
              }
              
            },
          }
        },
        bannerList:[],
        mobileBannerList:[],
        caseList:[],
        baseInfo: null,
        total:{},
        newsList:[],
        screenWidth: window.innerWidth,
      }
    },
    computed:{

    },
    created() {
      this.$emit('handleShow', true);
    },
    mounted() {
      if(this.screenWidth < 750){
        this.$emit('handleRed', true);
      }
      this.fetchCase();
      this.fetchBanner();
      this.fetchPartner();
      this.fetchHonor();
      this.fetchNews();
    },
    methods:{
      fetchNews(){
        ajaxPost({
          url: 'ajaxArticleHome',
          success(res){
            const {data, code, msg} = res;
            if(code === 200){
              this.newsList = data;
            } else {
              this.$message.warning(msg)
            }
          }
        }, this)
      },
      fetchPartner(){
        ajaxPost({
          url: 'ajaxPartner',
          success(res){
            const {data, code, msg} = res;
            if(code === 200){
              this.total = {
                ...this.total,
                partner: data.partner_list.length,
              };
            } else {
              this.$message.warning(msg)
            }
          }
        }, this)
      },
      fetchHonor(){
        ajaxPost({
          url: 'ajaxHonor',
          success(res){
            const {data, code, msg} = res;
            if(code === 200){
              this.total = {
                ...this.total,
                honor: data.honor_list.length,
              };
            } else {
              this.$message.warning(msg)
            }
          }
        }, this)
      },
      fetchBanner(){
        ajaxGet({
          url: `${this.ajaxUrl}api/common/getConfig`,
          params:{},
          success(res){
            const {code, data, msg} = res;
            if(code === 200) {
              this.bannerList = data.web_pc_bg_links;
              this.mobileBannerList = data.web_mobile_bg_links;
              this.baseInfo = data.config_list;
            }
          },
        },this);
      },
      fetchCase(){
        ajaxGet({
          url: `ajaxCaseHome`,
          params:{},
          success(res){
            const {code, data, msg} = res;
            if(code === 200) {
              this.caseList = data;
            }
          },
        },this);
      },
    },
  }
</script>
<style scoped lang="scss">
  .index-page {
    width: 100%;height: 100vh;position: relative;
    .swiper-box {
      width: 100%;height: 100%;
      .swiper-item {
        width: 100%;height: 100%;position: relative;
        .swiper-link { display: block;width: 100%;height: 100%;}
      }
      >>> .swiper-pagination {
        text-align: right;padding: 30px 180px;
        .swiper-pagination-bullet { width: 16px;height: 16px;background: #fff;transition: .3s;margin: 0 8px;}
        .swiper-pagination-bullet-active { width: 50px;border-radius: 10px;}
      }
    }
    .index-tool {
      width: 60px;position: absolute;right: 0;top: 40%;z-index: 10;
      .tool-item {
        width: 100%;height: 60px;border-top: 1px solid #fff;background: $theme-color;color: $color-white;cursor: pointer;transition: .35s;opacity: .6;font-size: 32px;
        i { transition: .35s;}
        &:first-child { border-top: none;}
        &:hover { opacity: 1;transform: translateX(-6px);}
        &:hover i { transform: scale(1.15);}
      }
    }
    .banner-one {
      z-index: 9;height: 100vh;top: 0;left: 7.5%;color: #fff;width: 85%;
      .font54 { font-size: 54px;}
      .font64 { font-size: 64px;}
    }
    .banner-yuanting {
      left: 0;top: 0;height: 100vh;width: 100%;z-index: 9;
      .yuanting {
        width: 16.66%;height: 100%;border-left: 5px solid #fff;
        &:first-child { border-left: none}
      }
      .yuanting-title {
        width: 193px;height: 426px;background: rgba($theme-color,.56);top: 228px;left: 53.5%;color: #fff;padding: 57px 25px 58px 15px;
        .tit-en { margin-top: 107px;font-size: 20px;writing-mode: vertical-lr;letter-spacing: 2px;}
        .tit-zh { margin-top: 22px;font-size: 50px;width: 60px;line-height: 1.8;}
        .tit-bg { width: 45px;height: 185px;font-size: 18px;padding: 40px 10px;background: url("../assets/index/banner_border.png") no-repeat;text-align: center;line-height: 4.5;}
      }
    }
    .banner-about {
      width: 60%;padding-left: 10%;z-index: 9;top: 0;right: 0;height: 100vh;color: #fff;padding-right: 150px;text-align: right;padding-top: 3%;
      /*background: linear-gradient(90deg,transparent,rgba($theme-color,.6),rgba($theme-color,.9));*/
      .about-title {
        margin-bottom: 42px;letter-spacing: 1px;
        .title-name { font-size: 22px;padding-right: 10px}
        .title-en { font-size: 86px;font-family: '黑体';word-spacing: -30px;letter-spacing: 4px;line-height: 1.2;}
        .title-sub { font-size: 50px;letter-spacing: 3px;line-height: 1.2}
      }
      .about-intro { font-size: 16px;line-height: 1.8;text-indent: 9em;text-align: left;padding-left: 20px;}
      .about-more {
        width: 160px;height: 50px;border: 2px solid #fff;font-size: 15px;margin-top: 46px;letter-spacing: 1px;cursor: pointer;transition: .3s;
        .square-left { width: 10px;height: 10px;background: #F0DA98;left: 0;top: 0;transition: .3s;}
        .square-right { width: 10px;height: 10px;background: #fff;right: 0;bottom: 0;transition: .3s;}
        &:hover {
          transform: rotate(3deg);
          .square-left { left: calc(100% - 10px);}
          .square-right { right: calc(100% - 10px);}
        }
      }
      .about-total {
        margin-top: 46px;text-align: center;
        .total-item {
          margin-left: 110px;letter-spacing: 1px;
          .item-num {
            color: #F0DB96;font-size: 20px;transition: .3s;
            span {
              font-weight: bold;font-size: 40px;transition: .3s;display: inline-block;
            }
          }
          &:hover .item-num span {
            animation: numRotateY linear .3s;
          }
          @keyframes numRotateY {
            0% {
              transform: rotateY(180deg);
            }
            100% {
              transform: rotateY(0deg);
            }
          }
          .item-name { font-size: 16px;margin-top: 20px;line-height: 1;}
          &:first-child { margin-left: 0;}
        }
      }
      & ~ .index-tool {
        .tool-item {
          background: rgba(255,255,255,.2);border-top-color: $theme-color;
          &:hover {background: $color-white;}
        }
      }
    }
    .banner-case {
      width: 100%;padding: 13vh 70px 0 70px;z-index: 9;top: 0;right: 0;height: 100vh;color: #fff;
      .case-item {
        width: 33%;margin-right: 0.5%;height: 38vh;margin-top: 10px;cursor: pointer;overflow: hidden;
        &:nth-child(2) { left: -33%;}
        &:nth-child(3) { left: -33%;}
        &:last-child { margin-right: 0;}
        .item-info {
          bottom: 0;left: 0; width: 100%;padding: 24px 30px;transition: .5s;background: rgba(0,0,0,.2);
          .info-circle { width: 18px;height: 18px;border: 3px solid #fff;border-radius: 50%;margin-right: 12px;position: relative;top: -1px;}
          .info-title { font-size: 16px;letter-spacing: 6px;}
        }
        .img-cover { transition: .5s;}
        &:hover {
          .img-cover { transform: scale(1.08);}
          .item-info {
            background: rgba(0,0,0,.5);
          }
        }
      }
      .card-intro {
        width: 33%;height: 38vh;margin-top: 10px;background: rgba(255,255,255,.5);z-index: 9;right: -67%;padding: 30px 30px 20px 30px;
        .intro-title {
          text-align: center;font-weight: bold;line-height: 1.5;margin-top: 10px;
          .title-name { font-size: 30px;color: $theme-color;position: relative;z-index: 2;letter-spacing: 15px;}
          .title-en { font-size: 62px;color: rgba($theme-color,.3);margin-top: -78px;font-family: 'fangsong';letter-spacing: 24px;}
        }
        .intro-text { font-size: 15px;color: #000;line-height: 1.8;margin-top: -5px;height: 190px;overflow: hidden;}
        .intro-more {
          padding: 0 30px;height:40px;font-size: 14px;color: $theme-color;border: 2px solid $theme-color;letter-spacing: 1px;cursor: pointer;transition: .3s;margin-top: 6px;
          .more-circle1 { width: 8px;height: 8px;background: $theme-color;left: 0;top: 0;transition: .3s;}
          .more-circle2 { width: 8px;height: 8px;background: $theme-color;right: 0;bottom: 0;transition: .3s;}
          &:hover {
            transform: rotate(3deg);
            .more-circle1 { left: calc(100% - 8px);}
            .more-circle2 { right: calc(100% - 8px);}
          }
        }
      }
    }
    .banner4 {
      left: 0;right: 0;bottom: 62px;margin: 0 auto;width: 1200px;background: rgba(255,255,255,.65);padding: 54px 35px 40px 35px;
      .ban4-item {
        width: 25%;color:$theme-color;
        .item-img { 
          width: 212px;height: 114px;overflow: hidden;
          img { transition: .35s;}
        }
        .item-date { font-size: 18px;margin-top: 8px;}
        .item-line {
          width: 100%;height: 1px;border-bottom: 1px dashed $theme-color;margin: 16px auto;
          &::before { position: absolute;content: '';width: 12px;height: 12px;border: 2px solid $theme-color;border-radius: 50%;left: calc(50% - 6px);top: -5px;box-sizing: border-box;transition: .35s;}
        }
        .item-title { margin: auto;width: 90%;font-size: 16px;height: 44px;text-align: center;transition: .35s;}
        &:hover {
          .item-title { text-decoration: underline;transform: scale(1.05);}
          .item-img img { transform: scale(1.1);}
          .item-line::before { width: 40px;border-radius: 10px;left: calc(50% - 20px);}
        }
      }
    }
  }
  @media screen and (max-width: 750px) {
    .index-page {
      .banner-one {
        left:0;width: 100%;padding: 0 16px;
        .font54 { font-size: 22px;}
        .font64 { font-size: 24px;margin-top: 10px;}
      }
      .index-tool {
        top: 65%;width: 40px;
        .tool-item { height: 40px;font-size: 26px;}
      }
      .swiper-box {
        >>> .swiper-pagination {
          padding: 10px 20px;
          .swiper-pagination-bullet { width: 10px;height: 10px;margin: 0 5px;}
          .swiper-pagination-bullet-active { width: 28px;}
        }
      }
      .banner-case {
        margin: 11vh 0;padding: 0 16px;
        // .case-item {
        //   width: 48%;margin: 8px 1%;height: 25vh;
        //   &:nth-child(2) { left: auto;margin-right: 10%;}
        //   &:nth-child(3) { left: auto;}
        //   .item-info {
        //     padding: 6px 10px;
        //     .info-title { overflow:hidden;text-overflow:ellipsis;white-space: nowrap;letter-spacing: 0;font-size: 15px;}
        //     .info-circle { flex: 0 0 10px;height: 10px;margin-right: 5px;border: 2px solid #fff;}
        //   }
        // }
        .card-intro {
          position: absolute;right: 16px;top: 0;width: 44%;height: 25vh;padding: 20px 5px;
          .intro-title {
            .title-name { font-size: 22px;letter-spacing: 10px;}
            .title-en { font-size: 40px;letter-spacing: 10px;margin-top: -54px;font-family: '微软雅黑';}
          }
          .intro-text { display: none;}
          .intro-more {
            padding: 0 18px;height: 30px;font-size: 12px;margin: 4vh auto 0 auto;
            .more-circle1 { width: 6px;height: 6px;}
            .more-circle2 { width: 6px;height: 6px;}
          }
        }
      }
      .banner-about {
        width: 100%;padding: 0 16px;
        .about-title {
          margin-bottom: 5vh;
          .title-name { font-size: 15px;}
          .title-en { font-size: 45px;}
          .title-sub { font-size: 18px;letter-spacing: 0;margin-right: 6px;}
        }
        .about-intro {font-size: 15px;padding-left: 0;}
        .about-more {
          width: 110px;font-size: 12px;border: 1px solid #fff;height: 30px;margin-top: 5vh;margin-right: 20px;
          .square-left { width: 8px;height: 8px;}
          .square-right { width: 8px;height: 8px;}
        }
        .about-total {
          margin-top: 5vh;margin-right: 20px;
          .total-item {
            margin: 0 0 0 10px;
            .item-num {
              font-size: 16px;
              span { font-size: 24px;}
            }
            .item-name { font-size: 12px;margin-top: 10px;}
          }
        }
      }
      .banner-yuanting {
        .yuanting {
          border-left: 1px solid #fff;width: 25%;
          &:nth-child(1),&:nth-child(2) { display: none;}
        }
        .yuanting-title {
          transform: scale(0.5);padding-bottom: 30px;height: 350px;top: 21%;left: 24%;
        }
      }
      .mobile-banner-case {
        height: 100%;left: 16px;right: 16px;top: 0;padding-top:60px;
        .mobile-banner-case-header { font-size: 1.8rem;font-weight: 400;color: #537353;line-height: 2;font-family: monospace;}
        .mobile-banner-case-line { width: 32px;height: 3px;background: #537353;}
        .case-list {
          margin-top: 14px;width: 100%;max-height:75vh;overflow: auto;
          .case-item { 
            width: 47.5%;margin-right: 5%;height: 16.5vh;position: relative;margin-top:14px;background: $theme-color;
            &:nth-child(2n) { margin-right: 0;}
            .img-cover { display: block;}
            .item-title { position: absolute;left: 8px;right: 6px;bottom: 6px;font-size: 15px;color: #fff;}
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Index.vue